import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './style.css';

import Home from './views/home';
import Products from './views/products';
import ContactUs from './views/contact-us';
import NotFound from './views/not-found';
import PrivacyPolicy from './views/privacy-policy';
import CookiesPolicy from './views/cookies-policy';
import MainNavbar from './components/mainnavbar';
import Mainfooter from './components/mainfooter';

const App = () => {
  return (
    <Router>
      <MainNavbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cookies-policy" element={<CookiesPolicy />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Mainfooter />
    </Router>
  );
};

export default App;
